var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AppFactoryLockedError = /** @class */ (function (_super) {
    __extends(AppFactoryLockedError, _super);
    function AppFactoryLockedError(method) {
        return _super.call(this, "You can not call AppFactory.\"".concat(method, "\"() when the factory is allready locked.")) || this;
    }
    return AppFactoryLockedError;
}(Error));
export { AppFactoryLockedError };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXBwRmFjdG9yeUxvY2tlZEVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2ZlYXR1cmVzL2NvcmUvZXJyb3JzL0FwcEZhY3RvcnlMb2NrZWRFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTtJQUEyQyx5Q0FBSztJQUM5QywrQkFBWSxNQUFNO2VBQ2hCLGtCQUNFLHdDQUFnQyxNQUFNLDhDQUEwQyxDQUNqRjtJQUNILENBQUM7SUFDSCw0QkFBQztBQUFELENBQUMsQUFORCxDQUEyQyxLQUFLLEdBTS9DIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIEFwcEZhY3RvcnlMb2NrZWRFcnJvciBleHRlbmRzIEVycm9yIHtcbiAgY29uc3RydWN0b3IobWV0aG9kKSB7XG4gICAgc3VwZXIoXG4gICAgICBgWW91IGNhbiBub3QgY2FsbCBBcHBGYWN0b3J5LlwiJHttZXRob2R9XCIoKSB3aGVuIHRoZSBmYWN0b3J5IGlzIGFsbHJlYWR5IGxvY2tlZC5gXG4gICAgKTtcbiAgfVxufVxuIl19